var _defs, _path, _path2, _polygon, _polygon2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJestJsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.25 439.89",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#c21325;}.a,.b{stroke:#fff;stroke-width:20px;}.b{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jest-js-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M334.92,218.1c-.54.33-18.35-2.66-40.67-4.17a447.59,447.59,0,0,0-56.74,0c-14,1-32.44-6.09-34.64,2.28-8.24,31.35-26,58.66-48.51,79.93A163.89,163.89,0,0,1,97,331.73c-25-12.84-36.81-41.4-26.16-66.44,8.45-19.87,18.28-41.74.13-46.75-13.21-3.64-20.46,9-25.54,22.55C35.69,267,17.2,293.83,11.93,325.61c-5.56,33.54,0,69.15,29,89.25,67.56,46.83,140.9-29,218.23-48.09,28-6.92,58.78-5.8,83.47-20.1a69.92,69.92,0,0,0,34.23-48.52C382.43,266,365.71,234.09,334.92,218.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.87,216.19c-8.24,31.35-26,58.66-48.51,79.93A163.84,163.84,0,0,1,97,331.73c-25-12.84-36.8-41.4-26.15-66.44,8.45-19.87,18.28-41.74.13-46.75-13.21-3.64-20.47,9-25.54,22.55C35.69,267,17.2,293.84,11.93,325.61c-5.56,33.54,0,69.15,29,89.25,67.56,46.83,140.9-29,218.23-48.09,28-6.92,58.78-5.8,83.47-20.1a69.92,69.92,0,0,0,34.23-48.52c5.58-32.13-11.14-64.06-41.93-80"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "264.89 91.17 319.21 201.98 384.31 10 145.32 10 210.26 201.64 264.89 91.17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "264.89 91.17 319.21 201.98 384.31 10 145.32 10 210.26 201.64 264.89 91.17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 198.99,
    cy: 216.58,
    r: 40.95
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 198.99,
    cy: 216.58,
    r: 40.95
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 332.37,
    cy: 216.58,
    r: 40.95
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 332.37,
    cy: 216.58,
    r: 40.95
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 65.1,
    cy: 216.88,
    r: 40.94
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 65.1,
    cy: 216.88,
    r: 40.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJestJsIcon);
export default __webpack_public_path__ + "static/media/jest-js-icon.62f7f2b2200499bc1caae57294534ae3.svg";
export { ForwardRef as ReactComponent };